import { render, staticRenderFns } from "./MainMenuTmp.vue?vue&type=template&id=006ef10b&scoped=true"
import script from "./MainMenuTmp.vue?vue&type=script&lang=js"
export * from "./MainMenuTmp.vue?vue&type=script&lang=js"
import style0 from "./MainMenuTmp.vue?vue&type=style&index=0&id=006ef10b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ef10b",
  null
  
)

export default component.exports